export const reviewSchema = {
  'medical-fundraising': {
    '@context': 'http://schema.org',
    '@type': 'Product',
    'name': 'Medical Fundraising: Get Financial Help for Medical Treatments in India - Ketto',
    'description': 'Start a FREE Medical Crowdfunding campaign with Ketto! Raise funds to get financial help for your high-cost medical treatments in India.',
    'brand':
    {
      '@type': 'Thing',
      'name': 'Ketto.Org'
    },
    'aggregateRating':
    {
      '@type':
        'AggregateRating',
      'ratingValue':
        '4.5',
      'reviewCount':
        '1584'
    }
  },
  'cancer-crowdfunding': {
    '@context': 'http://schema.org',
    '@type': 'Product',
    'name': 'Fundraising for Cancer: Get Financial Help for Cancer Patients - Ketto',
    'description': 'Start FREE Cancer Crowdfunding campaign with Ketto! Get financial support for cancer patients in India to fund their treatments.',
    'brand':
    {
      '@type': 'Thing',
      'name': 'Ketto.Org'
    },
    'aggregateRating':
    {
      '@type':
        'AggregateRating',
      'ratingValue':
        '4.5',
      'reviewCount':
        '1584'
    }

  },
  'fundraising-for-education': {
    '@context': 'http://schema.org',
    '@type': 'Product',
    'name': 'Fundraising for Education - Raise Funds for Education in India - Ketto',
    'description': 'Start an education fundraising campaign with Ketto! Achieve your academic goals with crowdfunding campaign and raise funds for your education.',
    'brand':
    {
      '@type': 'Thing',
      'name': 'Ketto.Org'
    },
    'aggregateRating':
    {
      '@type':
        'AggregateRating',
      'ratingValue':
        '4.5',
      'reviewCount':
        '1584'
    }
  },
  'help-children': {
    '@context': 'http://schema.org',
    '@type': 'Product',
    'name': 'Child Welfare - Girl Education, Meals & Medical Funding | Ketto',
    'description': 'Support child welfare, girl child education, daily meals and medical treatments by starting a crowdfunding campaign on Ketto. Remember, children are our nations future, and they hold the key to a better tomorrow!',
    'brand':
    {
      '@type': 'Thing',
      'name': 'Ketto.Org'
    },
    'aggregateRating':
    {
      '@type':
        'AggregateRating',
      'ratingValue':
        '4.5',
      'reviewCount':
        '1584'
    }

  },
  'animal-fundraising': {
    '@context': 'http://schema.org',
    '@type': 'Product',
    'name': 'Animal Crowdfunding – Fundraising For Stray Animals & NGOs - Ketto',
    'description': 'With Ketto.org you can start crowdfunding campaign to raise funds for stray animals and NGOs who are working towards wellbeing for animals such as dogs, cats, cows and more.',
    'brand':
    {
      '@type': 'Thing',
      'name': 'Ketto.Org'
    },
    'aggregateRating':
    {
      '@type':
        'AggregateRating',
      'ratingValue':
        '4.5',
      'reviewCount':
        '1584'
    }
  },
  'creative-fundraising': {
    '@context': 'http://schema.org',
    '@type': 'Product',
    'name': 'Creative Crowdfunding – Raise Funds For Creative & Entrepreneurial Projects - Ketto',
    'description': 'Creative crowdfunding can help raise funds for creative projects such movies, music, theatre plays and entrepreneurs to fund their startup. Visit Ketto.org to start your campaign today!',
    'brand':
    {
      '@type': 'Thing',
      'name': 'Ketto.Org'
    },
    'aggregateRating':
    {
      '@type':
        'AggregateRating',
      'ratingValue':
        '4.5',
      'reviewCount':
        '1584'
    }
  },
  'sports-crowdfunding': {
    '@context': 'http://schema.org',
    '@type': 'Product',
    'name': 'Sports Fundraising - Fundraising for Sports Made Easy - Ketto',
    'description': 'Start your Sports fundraising campaign with Ketto to raise funds for your sports teams, clubs, event, or sporting activity.',
    'brand':
    {
      '@type': 'Thing',
      'name': 'Ketto.Org'
    },
    'aggregateRating':
    {
      '@type':
        'AggregateRating',
      'ratingValue':
        '4.5',
      'reviewCount':
        '1584'
    }
  },
  'transplant-crowdfunding': {
    '@context': 'http://schema.org',
    '@type': 'Product',
    'name': 'Transplant Fundraising – Fundraising for Transplant Treatment in India - Ketto',
    'description': 'Fundraising for transplant made easy with Ketto! Get funding for organs transplant treatments through transplant crowdfunding.',
    'brand':
    {
      '@type': 'Thing',
      'name': 'Ketto.Org'
    },
    'aggregateRating':
    {
      '@type':
        'AggregateRating',
      'ratingValue':
        '4.5',
      'reviewCount':
        '1584'
    }
  }
};
